export default __webpack_public_path__ + "static/media/275.e65c3ab7.png";